import React from 'react';

import styles from './GameControls.scss';
import KeyboardIcon from './keyboard-control.svg';
import MouseIcon from './mouse-control.svg';

function GameControls(props) {
  const mouseControl = props.mouseControl ? (
    <MouseIcon className="GameControls__icon" />
  ) : null;
  const keyboardControl = props.keyboardControl ? (
    <KeyboardIcon className="GameControls__icon" />
  ) : null;
  const combinedControl =
    props.mouseControl && props.keyboardControl ? (
      <span className="GameControls__icon-connector">+</span>
    ) : null;
  const text =
    props.gameControlsText.substring(0, 3) === '<p>'
      ? props.gameControlsText
      : `<p>${props.gameControlsText}</p>`;
  return (
    <div className="GameControls">
      <header className="GameControls__header">
        <div className="GameControls__icons">
          {mouseControl}
          {combinedControl}
          {keyboardControl}
        </div>
        <h4 className="GameControls__headline">Game Controls</h4>
      </header>
      <div
        className="GameControls__details"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}

export default GameControls;
